exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p {\n  margin-bottom: 0;\n  color: black; }\n\ntextarea.form-control:disabled {\n  background-color: white !important; }\n\n.file-name {\n  font-weight: bold;\n  margin-right: 15px; }\n\nspan.oi {\n  font-size: 16px; }\n\n.preview {\n  cursor: pointer;\n  margin-left: 20px; }\n\n.img-title {\n  font-weight: bold;\n  color: black; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/bom-table/bom-comment/bom-comment.component.scss
// module id = ../../../../../src/app/bom-table/bom-comment/bom-comment.component.scss
// module chunks = main